export { default as ViewListUserSolidIcon } from './ViewListUserSolidIcon';
